<script lang="ts" context="module"></script>

<script lang="ts">
    import Icon from "@components/material/Icon.svelte"
    import type { NoticeTypes } from "@components/bottomPopup/Notice.module"

    export let headline: string
    export let detail: string
    export let type: NoticeTypes = "regular" // danger defaults to the cancel button
</script>

<div>
    {#if headline}
        <h3>{headline}</h3>
    {/if}
    {#if detail}
        <span>{detail}</span>
    {/if}
</div>

<style>
h3 {
  margin-bottom: 1em;
  text-align: center;
}

span {
  display: block;
  margin-bottom: 1em;
  text-align: center;
}
</style>
